module.exports = __webpack_public_path__ + "img/movii.5d53b00.png";